<script setup>
import { computed, ref } from "vue";
import {
	mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiFileTableOutline, mdiFilePdfBox, mdiPrinter,
	mdiPlusCircle, mdiDownload, mdiSearchWeb, mdiMagnify, mdiBroom, mdiGraphql
} from "@mdi/js";// LRR https://materialdesignicons.com/
import CardBoxModal from "@/Components/CardBoxModal.vue";
import CardBoxModalFrame from "@/Components/CardBoxModalFrame.vue";
import TableCheckboxCell from "@/Components/TableCheckboxCell.vue";
import BaseLevel from "@/Components/BaseLevel.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import UserAvatar from "@/Components/UserAvatar.vue";
import { Inertia } from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-vue3';
import { read, utils, writeFileXLSX } from 'xlsx';
import BaseIcon from "@/Components/BaseIcon.vue";
import IconRounded from "@/Components/IconRounded.vue";
import pdfMake, { PropertyDescriptor } from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import BreezeInput from '@/Components/Input.vue';
const mainStore = defineProps({
	data: Array,
	checkable: Boolean,
	massDelete: Boolean,
	updateable: Boolean,
	visualable: Boolean,
	isCanActive: Boolean,
	deleteable: Boolean,
	exporteable: Boolean,
	fields: Array,
	ruta: String,
	modulo: String,
	modulos: String,
	noSearch: Boolean,
	showIndex: Boolean,
	numberItems: {
		type: Number,
		default: 25
	},
	noPaginate: Boolean,
	searchAdvance: Boolean,
	changeOption1: Boolean,
	changeSelect1: Boolean,
	titleSelect1: String,
	select1: Object,// <-- Muestra waringn si lo paso como Array, llega como un sólo objecto
	originId: Number,
	originType: String,
	printLine: Boolean,
	titleExport: String,
	labelprint1: String
});
//console.log(mainStore.fields)
// - LRR store no definido
//const mainStore = useMainStore();
//const items = computed(() => mainStore.clients);
//let me = this;
/*const mainStore = {"users": [
						{"id":1,"user": "lenin", "name":"Lenin"},
						{"id":2,"user": "lucy", "name":"Lucy"},
						{"id":3,"user": "lucy", "name":"Lucy"},
						{"id":4,"user": "lucy", "name":"Lucy"},
						{"id":5,"user": "lucy", "name":"Lucy"},
						{"id":6,"user": "lucy", "name":"Lucy"},
						{"id":7,"user": "lucy", "name":"Lucy"}
					]};
console.log(mainStore);
*/
//const mainStore = this.defineProps();

const searchField = ref('');
const searchVal = ref('');
const storeData = mainStore.data;
let titleExport = mainStore.titleExport

// Filtro avanzado
const searchFieldCol = ref({});
const campos = mainStore.fields
campos.forEach((field) => {
	searchFieldCol.value[field.col] = null

});
//console.log(searchFieldCol.value)
const isSearchAdvanced = ref(false)
const dataList = ref(null)
const valueReplace = ref([])
const canPrint = ref(false)

const listarData = () => {

	// Con Axios
	let url = '/' + mainStore.ruta + '/list';// Una ruta post para enviar el arreglo
	if (mainStore.originId && mainStore.originType == 'classroom') {
		url = '/students/classroom?id_classroom=' + mainStore.originId;// /students/classroom'+'?id_classroom='+id_classroom

		axios.get(url).then(function (response) {
			let respuesta = response.data;

			dataList.value = respuesta.datalist;
			//isSearchAdvanced.value = true
			console.log('Lista estudiantes');
			//console.log(dataList.value);
			//Inertia.reload({ only: ['studens']})
		}).catch(function (error) {
			console.log(error);
		});
	} else {
		//axios.get(url).then(function (response) {
		axios.post(url, searchFieldCol.value).then(function (response) {
			let respuesta = response.data;
			if (mainStore.modulo == 'estudiante') {
				dataList.value = respuesta.students;
				//canPrint.value = true// <-- Para la libreta de notas
			} else if (mainStore.modulo == 'diario') {
				dataList.value = respuesta.diarios;
			} else {
				dataList.value = respuesta.datalist;
				if (mainStore.modulo == 'admisionpuntaje') {
					valueReplace.value = respuesta.valuereplace
					canPrint.value = respuesta.canPrint
					titleExport = respuesta.titleExport
					console.log(valueReplace.value)
				}
			}

			//isSearchAdvanced.value = true
			console.log('filtrado');
			console.log(searchFieldCol.value)
			//console.log(dataList.value);
			//Inertia.reload({ only: ['studens']})
		}).catch(function (error) {
			console.log(error);
		});
	}



	// Con Inertia
	/* let ruta = mainStore.ruta + '-list-filter'
	Inertia.post(route(ruta, searchFieldCol.value))
	Inertia.reload({ only: ['data']}) */
}

const cleanAdvancedFilter = () => {
	campos.forEach((field) => {
		searchFieldCol.value[field.col] = null
	});
	listarData()
}
/* if (isSearchAdvanced.value) {
  console.log(dataList.value)
  storeData.value=dataList.value
} */
// Fin de filtro avanzado

// - LRR const getItemsByFilter = (field, search) => storeData.filter( data => data[field] === search)
// - LRR const getItemsByFilter = (field, search) => storeData.filter( data => data[field].includes(search))
//const getItemsByFilterAll = (search) => storeData.filter( data => data.map.toLowerCase().includes(search.toLowerCase()) )

const getItemsByFilter = (field, search) => storeData.filter(data => data[field] ? data[field].toLowerCase().includes(search.toLowerCase()) : '')
const getItemsByFilterNumber = (field, search) => storeData.filter(data => data[field] == search)

const getItemsByFilter2 = (field, search) => dataList.value.filter(data => data[field] ? data[field].toLowerCase().includes(search.toLowerCase()) : '')
const getItemsByFilterNumber2 = (field, search) => dataList.value.filter(data => data[field] == search)

const items = computed(() => {

	//mainStore.searchAdvance
	if (1 == 2) {
		console.log(storeData)
		const dataFilter = storeData.filter(data => {
			//if (data['apellidos'].includes(searchFieldCol.value['apellidos'])) return true

			//return Object.keys(searchFieldCol.value).every(key => {
			//return searchFieldCol.value[key] === data[key]
			//})

			let i = 0;
			let result = []
			for (var key in searchFieldCol.value) {
				if (typeof searchFieldCol.value[key] == 'number' || searchFieldCol.value[key]) {
					if (isNaN(searchFieldCol.value[key])) {
						console.log('text ')
						result[i] = data[key] && searchFieldCol.value[key] && data[key].toLowerCase().includes(searchFieldCol.value[key].toLowerCase())

					} else {
						console.log('number ')
						result[i] = data[key] === searchFieldCol.value[key]

					}
				} else {
					result[i] = false
				}

				i++
			}

			return (result[0] ? result[0] : '') && (result[1] ? result[1] : '')

			//return (result[0]?? false)
			//&& (result[1] ?? false)
			//&& (result[2] ?? false)
			//&& (result[3] ?? false)
			//&& (result[4] ?? false)
			// && (result[5] ?? false)
			//&& (result[6] ?? false)
			// && (result[7] ?? false)
			//&& (result[8] ?? false)
			//&& (result[9] ?? false)
			//&& (result[10] ?? false)
		})
		//console.log(dataFilter)
		if (dataFilter.length) {
			return dataFilter
		} else {
			return storeData
		}

		/* let searchFields = []
		let search = 0
		campos.forEach((field, index) => {
		  if (searchFieldCol.value[field.col] && (searchFieldCol.value[field.col] || searchFieldCol.value[field.col] === 0)) {
		    
			if ((searchFieldCol.value[field.col] >= 0) && (field.type == 'foraign' || field.type == 'boolean' || field.type == 'number')) {
			  console.log('filternumber')
			  console.log(searchFieldCol.value[field.col])
			  searchFields[index] = field.col
			  search++
			  //return getItemsByFilterNumber(field.col, searchFieldCol.value[field.col])
			} else {
			  console.log('filtertext')
			  console.log(field.col)
			  console.log(searchFieldCol.value[field.col])
			  search++
			  searchFields[index] = field.col
			  //return getItemsByFilter(field.col, searchFieldCol.value[field.col])
			}
		  }

		}); */


		/* if (search) {
		  console.log('pasa por el filtro')
		  
		  
		} else {
		  console.log('no hay filtro')
		  return storeData
		} */
	} else {
		// Método de búsqueda por un sólo campo
		if (searchField.value && (searchVal.value || searchVal.value === 0)) {// <-- texto o el valor pueda ser cero en booleanos

			// Estandaríazar por tipo de campo
			let col = mainStore.fields.map(c => c.col).indexOf(searchField.value)
			if (col >= 0 && (mainStore.fields[col].type == 'foraign' || mainStore.fields[col].type == 'boolean' || mainStore.fields[col].type == 'number')) {
				if (dataList.value) {
					return getItemsByFilterNumber2(searchField.value, searchVal.value)
				} else {
					return getItemsByFilterNumber(searchField.value, searchVal.value)
				}

			} else {
				if (dataList.value) {
					return getItemsByFilter2(searchField.value, searchVal.value)
				} else {
					return getItemsByFilter(searchField.value, searchVal.value)
				}

			}

		} else {
			if (dataList.value) {
				return dataList.value
			} else {
				return storeData
			}

		}
	}


});

//const items = computed(() => storeData);

const isModalActive = ref(false);
const isModalFullActive = ref(false);
const modalFullSrc = ref('');

const isModalDangerActive = ref(false);

//mainStore.numberItems
const perPage = ref(mainStore.numberItems);

const currentPage = ref(0);

const checkedRows = ref([]);

const itemsPaginated = computed(() =>
	items.value.slice(
		perPage.value * currentPage.value,
		perPage.value * (currentPage.value + 1)
	)
);

// LRR
//console.log(itemsPaginated)
const isShowAllPages = ref(false)

const numPages = computed(() => Math.ceil(items.value.length / perPage.value));

//const currentPageSearch = ref(currentPage.value + 1);// LRR
const currentPageHuman = computed(() => currentPage.value + 1);
//const currentPageHuman = computed(() => currentPageSearch.value);// + LRR 
const pagesList = computed(() => {
	const pagesList = [];

	for (let i = 0; i < numPages.value; i++) {
		pagesList.push(i);
	}

	return pagesList;
});
const remove = (arr, cb) => {
	const newArr = [];

	arr.forEach((item) => {
		if (!cb(item)) {
			newArr.push(item);
		}
	});

	return newArr;
};
const checked = (isChecked, client) => {
	if (isChecked) {
		checkedRows.value.push(client);
	} else {
		checkedRows.value = remove(
			checkedRows.value,
			(row) => row.id === client.id
		);
	}
};

// LRR
const selectRows = ref([])
const allCheckBox = ref(false)
const countChecked = ref(0)
const massaction = ref('')
const id_select1 = ref(0)

const cleanMassAction = () => {
	massaction.value = ''
	selectRows.value = []
	allCheckBox.value = false
	countChecked.value = 0
	id_select1.value = 0
}

/* console.log(selectRows[1])
console.log(selectRows[2])
console.log(allCheckBox) */

const countCheckedSingle = () => {
	countChecked.value = 0// <-- Reiniciar contador
	for (var i = 0; i < selectRows.value.length; i++) {

		if (selectRows.value[i + 1] == true) {
			countChecked.value++
		}
	}
}

const changeAllCheckBox = () => {
	//console.log(itemsPaginated.value.length)
	countChecked.value = 0// <-- Reiniciar contador
	for (var i = 0; i < itemsPaginated.value.length; i++) {
		selectRows.value[i + 1] = !selectRows.value[i + 1]
		if (selectRows.value[i + 1] == true) {
			countChecked.value++
		}
	}
}

const emit = defineEmits(["update:modelValue", "cancel", "confirm", "emitPromedios"]);

const emisiones = (mode, id) => {
	//value.value = false;// LRR creo que es un valor v-model cuando se use
	emit(mode, id);// Segundo parámetro es el evento
	console.log('tablemodeemit')
}

const showPromedios = (id) => emisiones("emitPromedios", id);

const massAction = (action) => {
	const ruta = mainStore.ruta + '-massaction'
	let arrayitems = []

	for (var i = 0; i < itemsPaginated.value.length; i++) {
		if (selectRows.value[i + 1] == true) {
			//arrayitems[i] = itemsPaginated.value[i].id
			if (mainStore.modulo == 'estudiante') {// <-- capturar selecciones masivas
				arrayitems[i] = itemsPaginated.value[i].id_person
			} else {
				arrayitems[i] = itemsPaginated.value[i].id
			}

		}
	}
	if (mainStore.originId && mainStore.originType == 'classroom') {
		/* axios.put(route(ruta), {
			'action' : action,
			'checkedRows' : arrayitems,
			'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
			'id_select1': id_select1.value
		  }).then((response) => { 
			  emit('confirm')// lsitar students
			  console.log('A EAP asignado');
		  }).catch((error) => {
			  console.log(error);
		}) */
		Inertia.put(route(ruta, {
			//'id' : id
			'action': action,
			'checkedRows': arrayitems,
			'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
			'id_select1': id_select1.value
		}
		))
		//emit('confirm')// lsitar students
		console.log('A EAP asignado');
	} else {
		Inertia.put(route(ruta, {
			//'id' : id
			'action': action,
			'checkedRows': arrayitems,
			'modulo': mainStore.modulo, //<-- Llevar el modulo al controlador
			'id_select1': id_select1.value
		}
		))
	}

	cleanMassAction()
	//console.log(arrayitems)
}

// LRR Ordenar por cada columna
const orderSentido = ref(false)// por defecto ASC
const orderByCol = (col) => {
	if (orderSentido.value == false) {
		items.value.sort((a, b) => (a[col] > b[col]) ? 1 : ((b[col] > a[col]) ? -1 : 0))
	} else {
		items.value.sort((a, b) => (a[col] < b[col]) ? 1 : ((b[col] < a[col]) ? -1 : 0))
	}
	orderSentido.value = !orderSentido.value
}

const rowID = ref(0);
const rowAction = ref('action');
const initModal = (id, action) => {
	//isErrorForm.value = false
	rowAction.value = action
	rowID.value = id;
	isModalDangerActive.value = true
}



const isConfirm = () => {
	//alert('Hola '+rowID.value+'modal es '+rowAction.value)

	// Acciones individuales desactivadas se usará el modal para acciones masivas
	/* const ruta = mainStore.ruta + '-' + rowAction.value
    
	if (rowAction.value == 'eliminar') {
	  Inertia.post(route(ruta, {
		  'id' : rowID.value,
		}
	  ))
	} else {
	  Inertia.put(route(ruta, {
		  'id' : rowID.value,
		}
	  ))
	} */

	// Mass Action
	if (massaction.value != '') {
		massAction(massaction.value)
	}

	/* if (rowAction.value == 'eliminar') {
	  items.value.slice(rowID.value)
	} */
	cleanVal()
	if (!mainStore.originId && mainStore.modulo == 'estudiante') {
		listar(selectCriterio.value, buscarCriterio.value)
	} else {
		if (mainStore.originId && mainStore.originType == 'classroom') {
			//listarData()
			//Inertia.reload({ only: ['data']})
			// se llamar a axios
			listarData()
			Inertia.reload({ only: ['students'] })
		} else {
			listarData()// Si hay filtros
			Inertia.reload({ only: ['datalist'] })
		}


		//listar(selectCriterio.value, buscarCriterio.value)
	}


}



const selectCriterio = ref('p.nombres');
const buscarCriterio = ref('');


const listar = (criterio, buscar) => {
	// + '?criterio=' + criterio + '&buscar=' + buscar
	let ruta = mainStore.ruta + '-list'
	Inertia.get(route(ruta, {
		'criterio': criterio,
		'buscar': buscar
	}
	))

	buscarCriterio.value = ''
	//}
}

const isCancel = () => {
	cleanVal()
}
const cleanVal = () => {
	rowID.value = 0;
	rowAction.value = ''
	modalFullSrc.value = ''
	massaction.value = ''

}

/**
 * LRR
 * Exportar
 */
// título <-- Se toma de una variable let

// Get Data
const modulos = mainStore.modulos
//console.log(modulos)
// UPD 230604 - Se agrega async para usar el await de construir la base 64 de la imagen
const exportFile = async (ext) => {
	if (ext == 'xlsx') {
		// Excel DOC https://docs.sheetjs.com/docs/csf/features/
		const expItems = items.value;
		const expFields = mainStore.fields;

		const dataExport = ref([])
		expItems.forEach((client, index) => {
			//Definir que el arreglo index también será un arreglo
			// y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined
			dataExport.value[index] = []
			expFields.forEach((field, index2) => {
				//if (field.type == 'boolean' || field.type == 'foraign') {
				if (field.type == 'text' || field.type == 'date' || field.type == 'month') {
					//dataExport.value[index][field.name] = field.replace[client[field.col]]
					dataExport.value[index][field.name] = client[field.col]
				} else if (field.type == 'replacefromid') {
					//dataExport[index][index2] = field.replace[client[field.col]]
					// Si hay un celda n definida hay error, por eso se agrega el -
					dataExport.value[index][field.name] = valueReplace.value[client.id] ? valueReplace.value[client.id] : '-'
				} else {
					//dataExport.value[index][field.name] = client[field.col]
					dataExport.value[index][field.name] = field.replace[client[field.col]]
				}

			})
		})
		//console.log(items.value);
		//console.log(dataExport.value);

		const ws = utils.json_to_sheet(dataExport.value)

		// Ancho de la primera columna
		/*
		var wscols = [
			{wch: 20}, // "characters"
			//{wpx: 50}, // "pixels"
			//,
			//{hidden: true} // hide column
		];
		ws['!cols'] = wscols;
		*/

		const wb = utils.book_new()
		utils.book_append_sheet(wb, ws, 'Data')
		writeFileXLSX(wb, modulos + 'Report.xlsx')
	} else {
		// PDF DOC https://pdfmake.github.io/docs/0.1/getting-started/client-side/
		// https://pdfmake.github.io/docs/0.1/document-definition-object/tables/
		pdfMake.vfs = pdfFonts.pdfMake.vfs;
		const expItems = items.value;
		const expFields = mainStore.fields.filter(col => !col.noexport);// <-- Quitar columnas si noexport es true
		//console.log(expFields)

		// Si se usaba ref había error pues no era un array explícito
		// Se declara la primera fila para los títulos
		let dataExport = []
		dataExport[0] = []
		expFields.forEach((field, index) => {
			dataExport[0][index] = field.name
		})

		//dataExport.value[0] = expFields.name
		expItems.forEach((client, index) => {
			//Definir que el arreglo index también será un arreglo
			// y así se crea el arreglo multidimensional Ref https://stackoverflow.com/questions/16300036/multidimensional-array-in-javascript-cannot-set-property-0-of-undefined

			// Todos los índices serán más 1 pues el cero lo tomó el título
			dataExport[index + 1] = []
			expFields.forEach((field, index2) => {
				//if (index == 0) {
				//if (index == 0) dataExport[index][index2] = field.name
				//} else {
				//if (field.type == 'boolean' || field.type == 'foraign') {
				if (field.type == 'text' || field.type == 'date' || field.type == 'month') {
					//dataExport[index][index2] = field.replace[client[field.col]]
					// Si hay un celda n definida hay error, por eso se agrega el -
					dataExport[index + 1][index2] = client[field.col] ? client[field.col] : '-'
				} else if (field.type == 'replacefromid') {
					//dataExport[index][index2] = field.replace[client[field.col]]
					// Si hay un celda n definida hay error, por eso se agrega el -
					dataExport[index + 1][index2] = valueReplace.value[client.id] ? valueReplace.value[client.id] : '-'
				} else {
					//dataExport[index][index2] = client[field.col]
					dataExport[index + 1][index2] = field.replace[client[field.col]] ? field.replace[client[field.col]] : '-'
				}
				//}

			})
		})
		//console.log(items.value);
		//console.log(dataExport);

		let colWith = []
		for (let i = 0; i < expFields.length; i++) {
			colWith[i] = 'auto'
		}
		//console.log(colWith);
		let pageOrientation = 'portrait';
		if (colWith.length > 6) {
			pageOrientation = 'landscape';
		}
		var docDefinition = {
			// a string or { width: number, height: number }
			pageSize: 'A4',

			// by default we use portrait, you can change it to landscape if you wish
			//pageOrientation: 'landscape',
			pageOrientation: pageOrientation,

			// [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
			//pageMargins: [ 40, 60, 40, 60 ],
			pageMargins: [40, 80, 40, 50],

			// Antiguo Header
			//header: [{ text: 'Total '+modulos+' : '+expItems.length, margin: [40, 10, 0, 0]}],

			// New header with image
			header: {
				// margin: [left, top, right, bottom]
				margin: 10,
				columns: [
					{
						margin: [40, 0, 0, 0],
						// usually you would use a dataUri instead of the name for client-side printing
						// sampleImage.jpg however works inside playground so you can play with it
						//image: 'http://'+window.location.host+'/img/logo.png',
						//image: 'https://sedecarabayllo.iepmonserrat.edu.pe/img/logo.png',
						//svg: `<svg> ...`),// <-- Usando svg OK, pero se debe poner un solo path
						//image: await getBase64ImageFromURL("/img/logo.png"),// <-- Usando base 64 OK
						//image: "@unensstorage/logosquare.png",// <-- Usando filesystem de laravel - no funciona :(
						image: await getBase64ImageFromURL("/documents/mycompany/logos/logomembrete.png"),// <-- Usando base 64 OK
						width: 40
					},
					{
						margin: [-30, 0, 0, 0],
						//text : 'COLEGIO UNENS\nEducación integral\n\n'+(titleExport ?? 'Total '+modulos+' : '+expItems.length),
						text: ' \n \n\n' + (titleExport ?? 'Total ' + modulos + ' : ' + expItems.length),
						alignment: 'center',
						style: 'header'
					}

				],

				//margin: [10, 0, 0, 10],
				/* text : (titleExport ?? 'Total '+modulos+' : '+expItems.length),
				alignment: 'left' */

			},

			footer: function (currentPage, pageCount) { return [{ text: currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 40, 0] }] },
			/*
			footer: function(currentPage, pageCount, pageSize) {
			// you can apply any logic and return any valid pdfmake element
  
			  return [
				{ text: 'simple text', alignment: (currentPage % 2) ? 'left' : 'right' },
				{ canvas: [ { type: 'rect', x: 170, y: 32, w: pageSize.width - 170, h: 40 } ] }
			  ]
			},
			*/


			content: [
				{
					// margin: [horizontal, vertical]
					//margin: [15, 20],// <-- Sólo aplica a la primera página
					layout: 'lightHorizontalLines', // optional
					table: {
						// headers are automatically repeated if the table spans over multiple pages
						// you can declare how many rows should be treated as headers
						headerRows: 1,

						// Ancho de columnas
						//widths: [ '*', 'auto', 100, '*' ],
						//widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
						widths: colWith,

						/*body: [
						  [ 'First', 'Second', 'Third', 'The last one', 'First', 'Second', 'Third', 'The last one' ],
						  [ 'Value 1', 'Value 2', 'Value 3', 'Value 4', 'Value 1', 'Value 2', 'Value 3', 'Value 4' ],
						  [ { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4', { text: 'Bold value', bold: true }, 'Val 2', 'Val 3', 'Val 4' ]
						]
						*/
						body: dataExport
					}
				}
			],
			styles: {
				header: {
					fontSize: 11,
					bold: true
				}/* ,
            anotherStyle: {
              italics: true,
              alignment: 'right'
            } */
			},
			defaultStyle: {
				fontSize: 9,
				bold: false
			}
		};
		//console.log(docDefinition.content[0].body)
		//pdfMake.createPdf(docDefinition).open();

		if (ext == 'print') {
			pdfMake.createPdf(docDefinition).print();
		} else {
			pdfMake.createPdf(docDefinition).download(modulos + 'Report');
		}

	}

}
//console.log(mainStore.fields);

const viewCard = (id) => {
	const ruta = mainStore.ruta + '-show'
	Inertia.get(route(ruta, {
		'id': id
	}
	))
}

// Obtener img base 64
const getBase64ImageFromURL = (url) => {
	return new Promise((resolve, reject) => {
		var img = new Image();
		img.setAttribute("crossOrigin", "anonymous");

		img.onload = () => {
			var canvas = document.createElement("canvas");
			canvas.width = img.width;
			canvas.height = img.height;

			var ctx = canvas.getContext("2d");
			ctx.drawImage(img, 0, 0);

			var dataURL = canvas.toDataURL("image/png");

			resolve(dataURL);
		};

		img.onerror = error => {
			reject(error);
		};

		img.src = url;
	});
}

</script>

<template>

	<!-- Modal -->
	<CardBoxModal v-model="isModalActive" title="Información del estudiante">
		<p>Lorem ipsum dolor sit amet <b>adipiscing elit</b></p>
		<p>This is sample modal</p>
	</CardBoxModal>

	<!-- Vista previa -->
	<CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
		<div class="flex justify-center w-full">
			<embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full"><!-- w-full es para documetnos w-auto para imágenes-->
		</div>
	</CardBoxModal>

	<CardBoxModal v-model="isModalDangerActive" title="Por favor confirmar" button="danger" has-cancel @confirm="isConfirm" @cancel="isCancel">
		<p>Confirmar esta acción masiva</p>
	</CardBoxModal>

	<!-- <CardBoxModal
        v-model="isModalDangerActive"
        title="Por favor confirmar"
        button="danger"
        has-cancel
        @confirm="isConfirm" @cancel="isCancel"
    >   
        <p>Está seguro de <b v-text="rowAction"></b></p>
        <p>Este registro?</p>
    </CardBoxModal> -->
	<!-- Fin modal -->

	<div class="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-4">
		<div class="col-span-2">
			<h2 class="mb-3">{{ modulos }} : {{ items.length }}</h2>
		</div>
		<!-- Reubicar botones de exportar -->
		<div class="col-span-2 lg:col-span-2">
			<template v-if="exporteable">
				<div class="inline-block pr-2">
					<IconRounded color="" :icon="mdiFilePdfBox" title="Exportar a PDF" class="ml-1 text-red-800" @click="exportFile('pdf')" />
				</div>
				<div class="inline-block">
					<IconRounded color="" :icon="mdiFileTableOutline" title="Exportar a Excel" class="ml-1 text-green-700" @click="exportFile('xlsx')" />
				</div>
				<!--<div class="inline-block">
            <IconRounded color="" :icon="mdiPrinter" title="Imprimir" class="ml-1 text-blue-700"
          @click="exportFile('print')" />
          </div>-->
			</template>
			<!--<BaseIcon :path="mdiFileTableOutline" :size="32" class="text-green-700"/>-->
		</div>
		<div v-if="!noPaginate" class="float-right col-span-2 lg:col-end-9">
			<select class="mb-3 rounded-lg" v-model="perPage">
				<option value="10">10</option>
				<option value="25">25</option>
				<option value="50">50</option>
				<option value="100">100</option>
				<option value="250">250</option>
				<option value="500">500</option>
				<option value="1000">1000</option>
			</select>
			<!--<span class="ml-1">
          Página  <input class="ml-1 w-16 border-l-transparent border-t-transparent border-r-transparent border-b-gray-600" type="number" v-model="currentPage"> de {{ numPages }}
        </span>-->
			<span class="ml-1">
				Pág.
				<select class="ml-1 w-18 border-l-transparent border-t-transparent border-r-transparent border-b-gray-600" v-model="currentPage">
					<option v-for="page in pagesList" :value="page">{{ (page + 1) }}</option>
				</select>
				de {{ numPages }}
			</span>
		</div>
	</div>
	<div v-if="!noSearch" class="grid grid-cols-4 lg:grid-cols-8 gap-4 mb-4" :class="(searchAdvance ? 'lg:hidden' : '')">
		<!-- Searchs @change="buscar=''; buscar2='';" -->
		<div class="col-span-2 lg:col-span-1">
			<select v-model="searchField" @change="searchVal = ''" class="mb-3 rounded-lg w-full">
				<option value="" selected>Buscar</option>
				<option v-for="field in fields" :value="field.col">{{ field.name }}</option>
			</select>
		</div>

		<div class="col-span-2 lg:col-span-2">
			<!--
          <span v-if="!searchField.indexOf('status')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option value="0" selected>Pte. pago</option>
            <option value="1" selected>Pagado</option>
          </select>
        </span>
        -- Tipo de estudiante columna 4 --
        <span v-else-if="searchField.includes('type')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option value="0" selected>Nuevo</option>
            <option value="1" selected>Antiguo</option>
            
          </select>
        </span>

        -- Files fileForLevel la columna 1 es de niveles --
        <span v-else-if="searchField.includes('src_object_id')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[1].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -- Files estudiante es de niveles --
        <span v-else-if="searchField.includes('id_level')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[5].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -- Files estudiantes es de classroom --
        <span v-else-if="searchField.includes('id_classroom')">
          <select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
            <option value="" selected>Todos</option>
            <option v-for="(field, index) in fields[6].replace" :value="index">{{ field }}</option>

          </select>
        </span>
        -->

			<!-- Mapear (crear array sólo de la columna col en el bojejto field) buscr si exise el nombre del campo y condicionar sólo foráneos o booleanos -->
			<span v-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'foraign' || fields[col].type == 'boolean')">
				<select class="ml-1 mb-3 rounded-lg w-full" v-model="searchVal">
					<option value="" selected>Todos</option>
					<option v-for="(field, index) in fields[col].replace" :value="index">{{ field }}</option>

				</select>
			</span>
			<span v-else-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'number')">
				<input class="ml-1 mb-3 rounded-lg w-full" type="number" v-model="searchVal">
			</span>
			<span v-else-if="(col = fields.map(c => c.col).indexOf(searchField)) >= 0 && (fields[col].type == 'date')">
				<input class="ml-1 mb-3 rounded-lg w-full" type="date" v-model="searchVal">
			</span>
			<span v-else>
				<input class="ml-1 mb-3 rounded-lg w-full" type="text" v-model="searchVal">
			</span>
		</div>

		<!-- Reubicar botones de exportar -->


		<!-- Múltiple búsqueda probar https://stackoverflow.com/questions/31831651/javascript-filter-array-multiple-conditions -->
	</div>

	<!-- LRR Inputa para buscar de forma más avanzada por criterio -->
	<!-- <BreezeInput id="search" type="text" class="inline-block w-full" v-model="buscarCriterio" autofocus
            autocomplete="label" @keyup.enter="listar(selectCriterio, buscarCriterio)" /> -->

	<!-- Checked rows -->
	<!-- - LRR <div v-if="checkedRows.length" class="p-3 bg-gray-100/50 dark:bg-slate-800">   -->
	<div v-if="countChecked" class="p-3 bg-gray-100/50 dark:bg-slate-800">
		<!-- <span
        v-for="(selectRow, index) in selectRows"
        :key="index"
        class="inline-block px-2 py-1 rounded-sm mr-2 text-sm bg-gray-100 dark:bg-slate-700"
        >
        {{ selectRow == true ? selectRow : ''}}
        </span> -->
		<span>
			{{ countChecked }} filas seleccionadas
		</span>
		<!-- - LRR <span
        v-for="checkedRow in checkedRows"
        :key="checkedRow.id"
        class="inline-block px-2 py-1 rounded-sm mr-2 text-sm bg-gray-100 dark:bg-slate-700"
        >
        {{ checkedRow.apellidos }}
        </span> -->
		<span>
			<select class="mb-3 rounded-lg" v-model="massaction">
				<option value="" disabled>Acción masiva</option>
				<option v-if="modulo == 'estudiante' && changeOption1" value="enabled">Habilitar Acceso</option>
				<option v-if="modulo == 'estudiante' && changeOption1" value="disabled">Deshabilitar Acceso</option>
				<option v-if="modulo == 'calification'" value="publicar">Publicar notas</option>
				<option v-if="modulo == 'calification'" value="nopublicar">No publicar notas</option>
				<option v-if="modulo == 'admisionpuntaje'" value="publicar">Publicar puntaje EAP</option>
				<option v-if="modulo == 'admisionpuntaje'" value="nopublicar">No publicar puntaje EAP</option>
				<option v-if="changeSelect1" value="changeSelect1">Cambiar {{ titleSelect1 }} seleccionado</option>
				<option v-if="massDelete" value="eliminar">Eliminar seleccionado</option>
				<!-- <option value="financiero_pp">Pdte. de pago</option>
            <option value="financiero_p">Pagado</option> -->
			</select>
		</span>
		<span v-if="changeSelect1 && massaction == 'changeSelect1'">
			<select class="ml-3 mb-3 rounded-lg" v-model="id_select1">
				<option value="" selected disabled>Seleccionar {{ titleSelect1 }}</option>
				<option v-for="(option, index) in select1" :value="index">{{ option }}</option><!-- Mostrar los curos del array construido por columns -->
			</select>
		</span>
		<span>
			<BaseButton color="info" small label="Confirmar" @click="isModalDangerActive = true" class="ml-4" />
			<!--  @click="massAction(massaction)" -->
			<!-- @click="massAction(checkedRows, massaction)" -->
		</span>
	</div>

	<table>
		<thead>
			<tr v-if="!noSearch && searchAdvance">
				<td v-if="checkable"></td>
				<td v-if="showIndex"></td>
				<td v-for="field in fields">
					<div v-if="!field.nosearch && (field.type == 'boolean' || field.type == 'foraign' || field.type == 'str2select')">
						<select class="ml-1 mb-3 rounded-lg w-full" v-model="searchFieldCol[field.col]">
							<option value="" selected></option>
							<option v-for="(f, index) in field.replace" :value="index">{{ f }}</option>

						</select>
					</div>
					<div v-else-if="!field.nosearch && field.type == 'number'">
						<input class="ml-1 mb-3 rounded-lg w-full" type="number" v-model="searchFieldCol[field.col]">
					</div>
					<div v-else-if="!field.nosearch && field.type == 'date'">
						<input class="ml-1 mb-3 rounded-lg w-full" type="date" v-model="searchFieldCol[field.col]">
					</div>
					<div v-else-if="!field.nosearch && field.type == 'month'">
						<input class="ml-1 mb-3 rounded-lg w-full" type="month" v-model="searchFieldCol[field.col]">
					</div>
					<div v-else-if="!field.nosearch && field.type == 'text'">
						<input class="ml-1 mb-3 rounded-lg w-full" type="text" v-model="searchFieldCol[field.col]" @keyup.enter="listarData()">
					</div>
					<div v-else>
						<span></span>
					</div>
				</td>
				<td>
					<!-- <BaseButtons type="justify-start lg:justify-end" no-wrap>
                <BaseButton
                color="info"
                :icon="mdiMagnify"
                small
                @click="listarData()"
                />
                <BaseButton
                color="white"
                :icon="mdiCloseCircle"
                small
                :inertiahref="route(ruta+'-list')"
                />

              </BaseButtons> -->
					<div class="flex justify-center">
						<BaseButton color="info" :icon="mdiMagnify" small @click="listarData()" class="mr-3" />
						<BaseButton color="danger" :icon="mdiBroom" small @click="cleanAdvancedFilter()" class="m-0" />
						<!-- <BaseButton color="danger" :icon="mdiBroom" small :inertiahref="route(ruta + '-list')" class="m-0" /> -->
					</div>
				</td>
			</tr>
			<tr>
				<th v-if="checkable">
					<label class="checkbox">
						<input v-model="allCheckBox" type="checkbox" @change="changeAllCheckBox()" />
						<span class="check" />
					</label>
				</th>
				<th v-if="showIndex">#</th>
				<!-- <TableCheckboxCell
              v-if="checkable"
              v-model="allCheckBox"
              @checked="changeAllCheckBox()"
            /> -->
				<th v-for="field in fields" @click="orderByCol(field.col)">{{ field.name }}
				</th>
				<!--<th>Creado</th>-->
				<th />
			</tr>
		</thead>
		<tbody>
			<!-- <tr v-for="client in itemsPaginated" :key="client.id"> -->
			<tr v-for="(client, index) in itemsPaginated" :key="index">
				<!-- <TableCheckboxCell
              v-if="checkable"
              v-model="selectRows[index+1]"
            /> -->
				<td v-if="checkable">
					<label class="checkbox">
						<input v-model="selectRows[index + 1]" type="checkbox" @change="countCheckedSingle()" />
						<span class="check" />
					</label>
					<!-- {{ index + 1 }} {{ selectRows[index+1] }} -->
				</td>
				<td v-if="showIndex" data-label="#">{{ index + 1 }}</td>
				<!-- <TableCheckboxCell
            v-if="checkable"
            @checked="checked($event, client)"
            /> -->
				<!--<td class="border-b-0 lg:w-6 before:hidden">
            <UserAvatar
                :username="client.ref"
                class="w-24 h-24 mx-auto lg:w-6 lg:h-6"
            />
            </td>-->
				<td v-for="field in fields" :data-label="field.name">
					<div v-if="field.type == 'boolean'">
						<!--<small v-if = "client[field.col]" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-emerald-500 border-emerald-500 text-white last:mr-0">
                    <span>Activo</span>
                  </small>
                  <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-red-500 border-red-500 text-white last:mr-0">
                    <span>Inactivo</span>
                  </small>-->

						<!-- Si el valor es mayor a cero entonces mostrar el campo reemplazado por texto -->
						<small v-if="client[field.col] == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-emerald-500 border-emerald-500 text-white last:mr-0">
							<span>{{ field.replace[client[field.col]] }}</span>
						</small>
						<small v-else-if="client[field.col] == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
							<span>{{ field.replace[client[field.col]] }}</span>
						</small>
						<small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
							<span>{{ field.replace[client[field.col]] }}</span>
						</small>
					</div>
					<div v-else-if="field.type == 'foraign'">
						<small v-if="client[field.col]" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0 mb-3">
							<span v-if="modulo == 'calification' && originType == 'classroom' && parseInt(field.replace[client[field.col]]) < 11" class="text-red-600">{{ field.replace[client[field.col]] }}</span>
							<span v-else>{{ field.replace[client[field.col]] }}</span>
						</small>
						<small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0 mb-3">
							<span>{{ field.replace[client[field.col]] }}</span>
						</small>
					</div>
					<div v-else-if="field.type == 'replacefromid'">
						{{ valueReplace[client.id] }}
					</div>
					<div v-else>
						{{ client[field.col] }}
					</div>

				</td>
				<!--<td data-label="Progress" class="lg:w-32">
            <progress
                class="flex w-2/5 self-center lg:w-full"
                max="100"
                :value="client.progress"
            >
                {{ client.progress }}
            </progress>
            </td>
            -->
				<!--<td data-label="Creado" class="lg:w-1 whitespace-nowrap">
            <small
                class="text-gray-500 dark:text-slate-400"
                :title="client.created"
                >{{ client.created_at }}</small
            >
            </td>-->
				<td class="before:hidden lg:w-1 whitespace-nowrap">
					<BaseButtons type="justify-start lg:justify-end" no-wrap>
						<BaseButton v-if="visualable" color="info" :icon="mdiEye" small @click="viewCard(client.id)" />
						<!--v-if="visualable"-->

						<!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white hover:bg-yellow-700 hover:border-yellow-700 hover:dark:bg-yellow-600 hover:dark:border-yellow-600 p-1 mr-3 last:mr-0 mb-3"
                -->
						<!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-emerald-600 dark:border-emerald-500 ring-emerald-300 dark:ring-emerald-700 bg-emerald-600 dark:bg-emerald-500 text-white hover:bg-emerald-700 hover:border-emerald-700 hover:dark:bg-emerald-600 hover:dark:border-emerald-600 p-1 mr-3 last:mr-0 mb-3"-->

						<BaseButton v-if="isCanActive && client.status == 0" color="success" :icon="mdiCheckCircle" small @click="isModalActive = true" />
						<BaseButton v-if="isCanActive && client.status" color="danger" :icon="mdiCloseCircle" small @click="isModalDangerActive = true" class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600 p-1 mr-3 last:mr-0 mb-3" />

						<!-- Show in file list  :href="route('file-open', {'srctype': client.src_object_type, 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename })" -->
						<BaseButton v-if="ruta == 'file'" color="info" :icon="mdiEye" small @click="(isModalFullActive = true, modalFullSrc = '/documents/' + client.filepath + '/' + client.filename)" class="hidden lg:grid" />
						<BaseButton v-if="ruta == 'file'" color="info" :icon="mdiDownload" small :href="route('file-download', { 'srctype': client.src_object_type, 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename })" target="_blank" @click="" />

						<BaseButton v-if="updateable" color="warning" :icon="mdiPencil" small :inertiahref="route(ruta + '-edit', { 'id': client.id })" />

						<BaseButton v-if="deleteable" color="danger" :icon="mdiTrashCan" small @click="initModal(client.id, 'eliminar')" />

						<!-- Caso libreta de notas -->
						<BaseButton v-if="modulo == 'estudiante' && printLine" color="info" :icon="mdiGraphql" label="gráfico" small @click="showPromedios(client.id)" />
						<BaseButton v-if="modulo == 'estudiante' && printLine" color="info" :icon="mdiPrinter" :label="labelprint1" small :href="'/calification/libreta' + '?id=' + client.id" target="_blank" />

						<!-- Caso Admisión Puntaje-->
						<BaseButton v-if="modulo == 'admisionpuntaje' && printLine && client.resultado == 1 && canPrint" color="info" :icon="mdiPrinter" :label="labelprint1" small :href="'/admisionpuntaje/diploma' + '?id=' + client.id + '&puesto=' + (valueReplace[client.id])" target="_blank" />
					</BaseButtons>
				</td>
			</tr>
		</tbody>
	</table>
	<div v-if="!noPaginate" class="p-3 lg:px-6 border-t border-gray-100 dark:border-slate-800">
		<BaseLevel>
			<!--<BaseButtons>
              <template v-if="pagesList.length < 11">
                <BaseButton
                v-for="page in pagesList"
                :key="page"
                :active="page === currentPage"
                :label="page + 1"
                :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                small
                @click="currentPage = page"
                />
              </template>
              <template v-else>
                <template v-for="page in pagesList" :key="page">
                  <BaseButton
                  v-if="page < 10"
                  :active="page === currentPage"
                  :label="page + 1"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="currentPage = page"
                  />
                  <BaseButton
                  v-if="page == 11 && isShowAllPages == false"
                  :label="'Ver todas las páginas'"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="isShowAllPages=true"
                  />
                  <BaseButton
                  v-if="isShowAllPages && page > 9"
                  :active="page === currentPage"
                  :label="page + 1"
                  :color="page === currentPage ? 'lightDark' : 'whiteDark'"
                  small
                  @click="currentPage = page"
                  />
                </template>
              </template>
          </BaseButtons>-->

			<small>Página {{ currentPageHuman }} de {{ numPages }}</small>
		</BaseLevel>
	</div>
</template>